'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import { unstable_useForkRef as useForkRef } from '@mui/utils';
import { ListActionTypes } from "./listActions.types.js";
import { listReducer as defaultReducer } from "./listReducer.js";
import { useControllableReducer } from "../utils/useControllableReducer.js";
import { areArraysEqual } from "../utils/areArraysEqual.js";
import { useTextNavigation } from "../utils/useTextNavigation.js";
import { extractEventHandlers } from "../utils/extractEventHandlers.js";
var EMPTY_OBJECT = {};
var NOOP = function() {};
var defaultItemComparer = function(optionA, optionB) {
    return optionA === optionB;
};
var defaultIsItemDisabled = function() {
    return false;
};
var defaultItemStringifier = function(item) {
    return typeof item === 'string' ? item : String(item);
};
var defaultGetInitialState = function() {
    return {
        highlightedValue: null,
        selectedValues: []
    };
};
/**
 * The useList is a lower-level utility that is used to build list-like components.
 * It's used to manage the state of the list and its items.
 *
 * Supports highlighting a single item and selecting an arbitrary number of items.
 *
 * The state of the list is managed by a controllable reducer - that is a reducer that can have its state
 * controlled from outside.
 *
 * By default, the state consists of `selectedValues` and `highlightedValue` but can be extended by the caller of the hook.
 * Also the actions that can be dispatched and the reducer function can be defined externally.
 *
 * @template ItemValue The type of the item values.
 * @template State The type of the list state. This should be a subtype of `ListState<ItemValue>`.
 * @template CustomAction The type of the actions that can be dispatched (besides the standard ListAction).
 * @template CustomActionContext The shape of additional properties that will be added to actions when dispatched.
 *
 * @ignore - internal hook.
 */ function useList(params) {
    var _params_controlledProps = params.controlledProps, controlledProps = _params_controlledProps === void 0 ? EMPTY_OBJECT : _params_controlledProps, _params_disabledItemsFocusable = params.disabledItemsFocusable, disabledItemsFocusable = _params_disabledItemsFocusable === void 0 ? false : _params_disabledItemsFocusable, _params_disableListWrap = params.disableListWrap, disableListWrap = _params_disableListWrap === void 0 ? false : _params_disableListWrap, _params_focusManagement = params.focusManagement, focusManagement = _params_focusManagement === void 0 ? 'activeDescendant' : _params_focusManagement, _params_getInitialState = params.getInitialState, getInitialState = _params_getInitialState === void 0 ? defaultGetInitialState : _params_getInitialState, getItemDomElement = params.getItemDomElement, getItemId = params.getItemId, _params_isItemDisabled = params.isItemDisabled, isItemDisabled = _params_isItemDisabled === void 0 ? defaultIsItemDisabled : _params_isItemDisabled, externalListRef = params.rootRef, _params_onStateChange = params.onStateChange, onStateChange = _params_onStateChange === void 0 ? NOOP : _params_onStateChange, items = params.items, _params_itemComparer = params.itemComparer, itemComparer = _params_itemComparer === void 0 ? defaultItemComparer : _params_itemComparer, _params_getItemAsString = params.getItemAsString, getItemAsString = _params_getItemAsString === void 0 ? defaultItemStringifier : _params_getItemAsString, onChange = params.onChange, onHighlightChange = params.onHighlightChange, onItemsChange = params.onItemsChange, _params_orientation = params.orientation, orientation = _params_orientation === void 0 ? 'vertical' : _params_orientation, _params_pageSize = params.pageSize, pageSize = _params_pageSize === void 0 ? 5 : _params_pageSize, _params_reducerActionContext = params.reducerActionContext, reducerActionContext = _params_reducerActionContext === void 0 ? EMPTY_OBJECT : _params_reducerActionContext, _params_selectionMode = params.selectionMode, selectionMode = _params_selectionMode === void 0 ? 'single' : _params_selectionMode, externalReducer = params.stateReducer, _params_componentName = params.componentName, componentName = _params_componentName === void 0 ? 'useList' : _params_componentName;
    if (process.env.NODE_ENV !== 'production') {
        if (focusManagement === 'DOM' && getItemDomElement == null) {
            throw new Error('useList: The `getItemDomElement` prop is required when using the `DOM` focus management.');
        }
        if (focusManagement === 'activeDescendant' && getItemId == null) {
            throw new Error('useList: The `getItemId` prop is required when using the `activeDescendant` focus management.');
        }
    }
    var listRef = React.useRef(null);
    var handleRef = useForkRef(externalListRef, listRef);
    var handleHighlightChange = React.useCallback(function(event, value, reason) {
        onHighlightChange === null || onHighlightChange === void 0 ? void 0 : onHighlightChange(event, value, reason);
        if (focusManagement === 'DOM' && value != null && (reason === ListActionTypes.itemClick || reason === ListActionTypes.keyDown || reason === ListActionTypes.textNavigation)) {
            var _getItemDomElement;
            getItemDomElement === null || getItemDomElement === void 0 ? void 0 : (_getItemDomElement = getItemDomElement(value)) === null || _getItemDomElement === void 0 ? void 0 : _getItemDomElement.focus();
        }
    }, [
        getItemDomElement,
        onHighlightChange,
        focusManagement
    ]);
    var stateComparers = React.useMemo(function() {
        return {
            highlightedValue: itemComparer,
            selectedValues: function(valuesArray1, valuesArray2) {
                return areArraysEqual(valuesArray1, valuesArray2, itemComparer);
            }
        };
    }, [
        itemComparer
    ]);
    // This gets called whenever a reducer changes the state.
    var handleStateChange = React.useCallback(function(event, field, value, reason, state) {
        onStateChange === null || onStateChange === void 0 ? void 0 : onStateChange(event, field, value, reason, state);
        switch(field){
            case 'highlightedValue':
                handleHighlightChange(event, value, reason);
                break;
            case 'selectedValues':
                onChange === null || onChange === void 0 ? void 0 : onChange(event, value, reason);
                break;
            default:
                break;
        }
    }, [
        handleHighlightChange,
        onChange,
        onStateChange
    ]);
    // The following object is added to each action when it's dispatched.
    // It's accessible in the reducer via the `action.context` field.
    var listActionContext = React.useMemo(function() {
        return {
            disabledItemsFocusable: disabledItemsFocusable,
            disableListWrap: disableListWrap,
            focusManagement: focusManagement,
            isItemDisabled: isItemDisabled,
            itemComparer: itemComparer,
            items: items,
            getItemAsString: getItemAsString,
            onHighlightChange: handleHighlightChange,
            orientation: orientation,
            pageSize: pageSize,
            selectionMode: selectionMode,
            stateComparers: stateComparers
        };
    }, [
        disabledItemsFocusable,
        disableListWrap,
        focusManagement,
        isItemDisabled,
        itemComparer,
        items,
        getItemAsString,
        handleHighlightChange,
        orientation,
        pageSize,
        selectionMode,
        stateComparers
    ]);
    var initialState = getInitialState();
    var reducer = externalReducer !== null && externalReducer !== void 0 ? externalReducer : defaultReducer;
    var actionContext = React.useMemo(function() {
        return _object_spread({}, reducerActionContext, listActionContext);
    }, [
        reducerActionContext,
        listActionContext
    ]);
    var _useControllableReducer = _sliced_to_array(useControllableReducer({
        reducer: reducer,
        actionContext: actionContext,
        initialState: initialState,
        controlledProps: controlledProps,
        stateComparers: stateComparers,
        onStateChange: handleStateChange,
        componentName: componentName
    }), 2), state = _useControllableReducer[0], dispatch = _useControllableReducer[1];
    var highlightedValue = state.highlightedValue, selectedValues = state.selectedValues;
    var handleTextNavigation = useTextNavigation(function(searchString, event) {
        return dispatch({
            type: ListActionTypes.textNavigation,
            event: event,
            searchString: searchString
        });
    });
    var previousItems = React.useRef([]);
    React.useEffect(function() {
        // Whenever the `items` object changes, we need to determine if the actual items changed.
        // If they did, we need to dispatch an `itemsChange` action, so the selected/highlighted state is updated.
        if (areArraysEqual(previousItems.current, items, itemComparer)) {
            return;
        }
        dispatch({
            type: ListActionTypes.itemsChange,
            event: null,
            items: items,
            previousItems: previousItems.current
        });
        previousItems.current = items;
        onItemsChange === null || onItemsChange === void 0 ? void 0 : onItemsChange(items);
    }, [
        items,
        itemComparer,
        dispatch,
        onItemsChange
    ]);
    var createHandleKeyDown = function(externalHandlers) {
        return function(event) {
            var _externalHandlers_onKeyDown;
            (_externalHandlers_onKeyDown = externalHandlers.onKeyDown) === null || _externalHandlers_onKeyDown === void 0 ? void 0 : _externalHandlers_onKeyDown.call(externalHandlers, event);
            if (event.defaultMuiPrevented) {
                return;
            }
            var keysToPreventDefault = [
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ];
            if (orientation === 'vertical') {
                keysToPreventDefault.push('ArrowUp', 'ArrowDown');
            } else {
                keysToPreventDefault.push('ArrowLeft', 'ArrowRight');
            }
            if (focusManagement === 'activeDescendant') {
                // When the child element is focused using the activeDescendant attribute,
                // the list handles keyboard events on its behalf.
                // We have to `preventDefault()` is this case to prevent the browser from
                // scrolling the view when space is pressed or submitting forms when enter is pressed.
                keysToPreventDefault.push(' ', 'Enter');
            }
            if (keysToPreventDefault.includes(event.key)) {
                event.preventDefault();
            }
            dispatch({
                type: ListActionTypes.keyDown,
                key: event.key,
                event: event
            });
            handleTextNavigation(event);
        };
    };
    var createHandleBlur = function(externalHandlers) {
        return function(event) {
            var _externalHandlers_onBlur, _listRef_current;
            (_externalHandlers_onBlur = externalHandlers.onBlur) === null || _externalHandlers_onBlur === void 0 ? void 0 : _externalHandlers_onBlur.call(externalHandlers, event);
            if (event.defaultMuiPrevented) {
                return;
            }
            if ((_listRef_current = listRef.current) === null || _listRef_current === void 0 ? void 0 : _listRef_current.contains(event.relatedTarget)) {
                // focus remains within the list
                return;
            }
            dispatch({
                type: ListActionTypes.blur,
                event: event
            });
        };
    };
    var getRootProps = function() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var externalEventHandlers = extractEventHandlers(externalProps);
        return _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, externalProps), {
            'aria-activedescendant': focusManagement === 'activeDescendant' && highlightedValue != null ? getItemId(highlightedValue) : undefined,
            tabIndex: focusManagement === 'DOM' ? -1 : 0,
            ref: handleRef
        }), externalEventHandlers), {
            onBlur: createHandleBlur(externalEventHandlers),
            onKeyDown: createHandleKeyDown(externalEventHandlers)
        });
    };
    var getItemState = React.useCallback(function(item) {
        var selected = (selectedValues !== null && selectedValues !== void 0 ? selectedValues : []).some(function(value) {
            return value != null && itemComparer(item, value);
        });
        var highlighted = highlightedValue != null && itemComparer(item, highlightedValue);
        var focusable = focusManagement === 'DOM';
        return {
            focusable: focusable,
            highlighted: highlighted,
            selected: selected
        };
    }, [
        itemComparer,
        selectedValues,
        highlightedValue,
        focusManagement
    ]);
    var contextValue = React.useMemo(function() {
        return {
            dispatch: dispatch,
            getItemState: getItemState
        };
    }, [
        dispatch,
        getItemState
    ]);
    React.useDebugValue({
        state: state
    });
    return {
        contextValue: contextValue,
        dispatch: dispatch,
        getRootProps: getRootProps,
        rootRef: handleRef,
        state: state
    };
}
export { useList };
